export default __webpack_public_path__ + "static/media/ElenaNNMA.4315291e.pdf";